import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from "react-router-dom"
import { Button, Flex, CircularProgress, FormControl, FormLabel, FormErrorMessage, Input, HStack, Select } from '@chakra-ui/react'
import Layout from '../layout'
import { createPostulacion, fetchActiveBolsa } from "../actions"
import { getEntity } from "../reducers"
import { Formik } from 'formik'
import { FormValidator } from '../utils/validationForms'

const BolsaForm = () => {

    const dispatch = useDispatch()

    const departamentos = useSelector(state => getEntity(state, 'departamento'))

    useEffect(() => {
        dispatch(fetchActiveBolsa())
    }, [])

    return (
        <Layout>

            <Flex maxW={"1400px"} flexDir={'column'} p={4} m={"auto"} mt={"2rem"} mb={"2rem"}>
                <Formik
                    initialValues={{
                        nombre: ''
                    }}
                    validate={values => FormValidator([
                        { field: 'nombre', value: values.nombre, rules: ['required'], lang: 'Nombre' },

                    ])}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        Promise.resolve(dispatch(createPostulacion(values)))
                            .then(() => {
                                setSubmitting(false)
                                resetForm()
                            })
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                        <form onSubmit={handleSubmit}>

                            <HStack>
                                <FormControl isInvalid={errors.nombre && touched.nombre}>
                                    <FormLabel>Nombre</FormLabel>
                                    <Input type={'text'} size="lg" name={"nombre"} onChange={handleChange} onBlur={handleBlur} value={values.nombre} />
                                    <FormErrorMessage>{errors.nombre}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.edad && touched.edad}>
                                    <FormLabel>Edad</FormLabel>
                                    <Input type={'number'} size="lg" name={"edad"} min={0} max={80} onChange={handleChange} onBlur={handleBlur} value={values.edad} step={1} />
                                    <FormErrorMessage>{errors.edad}</FormErrorMessage>
                                </FormControl>
                            </HStack>

                            <HStack>
                                <FormControl isInvalid={errors.telefono && touched.telefono}>
                                    <FormLabel>Telefono</FormLabel>
                                    <Input type={'text'} size="lg" name={"telefono"} onChange={handleChange} onBlur={handleBlur} value={values.telefono} />
                                    <FormErrorMessage>{errors.telefono}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.correo && touched.correo}>
                                    <FormLabel>Correo</FormLabel>
                                    <Input type={'text'} size="lg" name={"correo"} min={0} onChange={handleChange} onBlur={handleBlur} value={values.correo} />
                                    <FormErrorMessage>{errors.correo}</FormErrorMessage>
                                </FormControl>
                            </HStack>

                            <HStack>
                                <FormControl isInvalid={errors.direccion && touched.direccion}>
                                    <FormLabel>Dirección</FormLabel>
                                    <Input type={'text'} size="lg" name={"direccion"} onChange={handleChange} onBlur={handleBlur} value={values.direccion} />
                                    <FormErrorMessage>{errors.direccion}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.departamento && touched.departamento}>
                                    <FormLabel>Departamento</FormLabel>
                                    <Select type={'text'} size="lg" name={"departamento"} onChange={handleChange} onBlur={handleBlur} value={values.departamento} >
                                        <option value={""}>Seleccione departamento</option>
                                        {departamentos.map(departamentos =>
                                            <option value={departamentos.Departamento} key={departamentos.Departamento}>{departamentos.Departamento}</option>
                                        )}
                                    </Select>
                                    <FormErrorMessage>{errors.departamento}</FormErrorMessage>
                                </FormControl>
                            </HStack>

                            <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress /> : 'Crear'}
                            </Button>
                        </form>
                    )}
                </Formik>
            </Flex>
        </Layout >
    )
}

export default BolsaForm